import React from "react";
import ModalBase from "../../ModalBase";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Formsy from "formsy-react";
import withResetPasswordModal from "../../../../../hocs/withResetPasswordModal";
import FormBuilderWeb from "../../../../../lib/FormBuilder/FormBuilderWeb";
import SquaberButton from "../../../common/SquaberButton";

@withResetPasswordModal
class ResetPasswordModal extends ModalBase {
  getContent() {
    const { translate, formBuilder, hideModal } = this.props;

    return (
      <React.Fragment>
        <DialogTitle id="form-dialog-title">
          {translate("Reset password")}
        </DialogTitle>
        <DialogContent>
          <Formsy>
            <FormBuilderWeb {...formBuilder} />
          </Formsy>
        </DialogContent>
        <DialogActions>
          <SquaberButton
            color="secondary"
            onClick={() => {
              hideModal();
            }}
          >
            {translate("Cancel")}
          </SquaberButton>
          <SquaberButton
            onClick={() => {
              this.props.trigger({
                fields: formBuilder.fields,
                callback: () => {
                  hideModal();
                }
              });
            }}
            color="primary"
          >
            {translate("Send")}
          </SquaberButton>
        </DialogActions>
      </React.Fragment>
    );
  }
}

export default ResetPasswordModal;
